import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import toast from 'react-hot-toast';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux';
import {
  createSecurityKeyAction,
  getAllChatUserAction,
  getAllChatUserActionByNumber,
  getAllSecurityKeyAction,
  getChatsAction,
  getSecurityKeyAction,
  makeDefaultSecurityKeyAction,
} from '../../redux/actions/chatActions';
import { createVideoNotesAction, deleteVideoNotesAction, getAllVideoNotesAction, updateVideoNotesAction } from '../../redux/actions/videoNoteActions';

const useChatFunctions = socket => {
  const dispatch = useDispatch();
  const history = useHistory();
  const messagesStartRef = React.useRef(null);
  const messagesEndRef = React.useRef(null);
  const [lastTopMessage, setLastTopMessage] = React.useState({});
  const [acceptedUserLoading, setAcceptedUserLoading] = React.useState(false);
  const [groupUsersLoading, setgroupUsersLoading] = React.useState(false);
  const [allUsersLoading, setAllUsersLoading] = React.useState(false);
  const [showAddGroupMoal, setShowAddGroupMoal] = React.useState(false);
  const [showGroupInfoMoal, setShowGroupInfoMoal] = React.useState(false);
  const [acceptedUsers, setAcceptedUsers] = React.useState({});
  const [allUsers, setAllUsers] = React.useState([]);
  const [groupUsers, setGroupUsers] = React.useState({});
  const [selectedUser, setSelectedUser] = React.useState({});
  const [showSelectedUser, setShowSelectedUser] = React.useState(false);
  const [selectedNewUser, setSelectedNewUser] = React.useState({});
  const [acceptedUserSearch, setAcceptedUserSearch] = React.useState('');
  const [showChatRequests, setShowChatRequests] = React.useState(false);

  const [chatUserLoading, setChatUserLoading] = React.useState(false);
  const [chatSendLoading, setChatSendLoading] = React.useState(false);
  const [showEmojiBox, setShowEmojiBox] = React.useState(false);

  const [showErrorToast, setShowErrorToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  const [showReactBox, setShowReactBox] = React.useState({
    status: false,
    chat: {},
  });
  const [removedGroupId, setRemovedGroupId] = React.useState('');
  const [removedGroup, setRemovedGroup] = React.useState(false);
  const [selectedMessage, setSelectedMessage] = React.useState({});
  const [encryptedSecurityKey, setEncryptedSecurityKey] = React.useState({});
  const [decryptedSecurityKey, setDecryptedSecurityKey] = React.useState({});
  const [encryptedChatData, setEncryptedChatData] = React.useState({});
  const [decryptedChatData, setDecryptedChatData] = React.useState([]);
  const [groupedData, setGroupedData] = React.useState({});
  const [groupName, setGroupName] = React.useState();

  const [chatText, setChatText] = React.useState({ value: '', error: false });
  const [attachedFiles, setAttachedFiles] = React.useState([]);
  const fileInputRef = React.useRef(null);

  const [securityKeys, setSecurityKeys] = React.useState({});
  const [securityKeyModal, setSecurityKeyModal] = React.useState(false);
  const [securityKeyCreate, setSecurityKeyCreate] = React.useState(false);
  const [showSecurityKey, setShowSecurityKey] = React.useState(false);
  const topMessageRef = React.useRef(null);

  const [videoNotesModal, setVideoNotesModal] = React.useState(false);
  const [group, setGroup] = React.useState(false);
  const [messageCount, setMessageCount] = React.useState(0);
  const [cardListData, setCardListData] = React.useState([]);
  const [latestUnecryptedMessage, setLatestUnecryptedMessage] = React.useState(false);
  const [latestUnecryptedMessageObj, setLatestUnecryptedMessageObj] = React.useState({});
  const [videoNotesData, setVideoNotesData] = React.useState({
    loading: false,
    data: [],
  });
  const [videoNoteSelected, setVideoNoteSelected] = React.useState({});
  const [newVideoNoteText, setNewVideoNoteText] = React.useState({
    value: '',
    error: '',
  });
  const [newVideoNoteType, setNewVideoNoteType] = React.useState({
    value: '',
    error: '',
  });
  const [videoNotesDeleteModal, setVideoNotesDeleteModal] = React.useState({
    loading: false,
    status: false,
    data: {},
  });
  const [addNewVideoNoteModal, setAddNewVideoNoteModal] = React.useState({
    loading: false,
    status: false,
  });
  const [newVideoNote, setNewVideoNote] = React.useState({
    value: '',
    error: '',
  });
  const [noteType, setNoteType] = React.useState({
    value: 'internal',
    error: '',
  });

  const userLogin = useSelector(state => state.userLogin);
  const orgDetails = useSelector(state => state.orgDetails);
  const onlineUsers = useSelector(state => state.onlineUsers);

  React.useEffect(() => {
    if (
      userLogin &&
      userLogin.userInfo &&
      userLogin.userInfo.data &&
      userLogin.userInfo.data.user &&
      userLogin.userInfo.data.user.modules &&
      !userLogin.userInfo.data.user.modules.chat
    ) {
      history.push('/');
    }
  }, [history, userLogin]);

  const scrollToBottom = () => {
    messagesStartRef && messagesStartRef.current && messagesStartRef.current.scrollIntoView({ behavior: 'smooth' });
    messagesEndRef && messagesEndRef.current && messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToMessage = () => {
    topMessageRef && topMessageRef.current && topMessageRef.current.scrollIntoView();
  };
  const [loadMoreMsg, setLoadMoreMsg] = React.useState(false);
  React.useEffect(() => {
    if (loadMoreMsg) {
      scrollToMessage();
    }
  }, [loadMoreMsg, lastTopMessage]);

  React.useEffect(() => {
    if (!loadMoreMsg) {
      scrollToBottom();
    }
  }, [loadMoreMsg, chatUserLoading, showSecurityKey, chatSendLoading]);

  const getAcceptedUsers = React.useCallback(async () => {
    setAcceptedUserLoading(true);
    const data = await dispatch(getAllChatUserAction('accepted'));
    setAcceptedUsers(data);
    setAcceptedUserLoading(false);
  }, [dispatch]);

  const getAcceptedUsersWithoutLoading = React.useCallback(async () => {
    const data = await dispatch(getAllChatUserAction('accepted'));
    setAcceptedUsers(data);
  }, [dispatch]);

  React.useEffect(() => {
    if (socket) {
      socket.on('UpdateGroupResponse', response => {
        if (response) {
          const updatedData = acceptedUsers?.data?.map(group => {
            if (response.groupId === group.groupId) {
              return { ...group, name: response.name };
            }
            return group;
          });
          setAcceptedUsers({ ...acceptedUsers, data: updatedData });
          if (response.groupId === selectedUser.groupId) setGroupName(response.name);

          setToastMessage(response.message);
          setShowSuccessToast(true);
        }
      });
    }
  }, [acceptedUsers, selectedUser, setGroupName, socket]);

  useEffect(() => {
    if (socket) {
      socket.on('sendRequest', () => {
        getAcceptedUsersWithoutLoading();
      });
      socket.on('GroupRequestSendResponse', () => {
        getAcceptedUsersWithoutLoading();
      });
    }
  }, [socket]);

  const getAllUsers = React.useCallback(async () => {
    const data = await dispatch(getAllChatUserActionByNumber('fresh', 1));
    const newData = await data.data;
    setAllUsersLoading(true);
    setAllUsers(newData);
  }, [dispatch]);

  useEffect(() => {
    if (socket) {
      socket.on('createGroupRequestSuccess', response => {
        if (response.data.status) {
          setToastMessage('Sending Request');
          setShowSuccessToast(true);
          getAcceptedUsers();
        } else {
          setToastMessage('Request Not Send');
          setShowErrorToast(true);
        }
      });
    }
  }, [getAcceptedUsers, socket]);

  const getAllVideoNotes = React.useCallback(async () => {
    if (selectedUser && selectedUser._id && videoNotesModal) {
      setVideoNotesData({ loading: true, data: [] });
      const data = await dispatch(getAllVideoNotesAction(selectedUser._id));

      if (data && data.data && data.data.data) {
        setVideoNotesData({ loading: false, data: data.data.data });
      } else {
        setVideoNotesData({ loading: false, data: [] });
      }
    }
  }, [dispatch, selectedUser, videoNotesModal]);

  const handleSubmitVideoNote = async () => {
    if (userLogin && userLogin.userInfo && userLogin.userInfo.data && userLogin.userInfo.data.user && selectedUser && selectedUser._id) {
      if (newVideoNote.value === '' || newVideoNote.value.trim === '') {
        setNewVideoNote({
          ...newVideoNote,
          error: 'Please enter note ',
        });
      } else {
        setAddNewVideoNoteModal(oldData => ({
          ...oldData,
          loading: true,
        }));
        const formData = {
          noteBy: userLogin.userInfo.data.user._id,
          noteText: newVideoNote.value,
          noteType: noteType.value,
          noteOn: selectedUser._id,
        };

        const responseData = await dispatch(createVideoNotesAction(formData));
        setAddNewVideoNoteModal(oldData => ({
          ...oldData,
          loading: false,
        }));

        if (responseData && responseData.status === 'success') {
          toast.success('Note saved successfully!');
          setAddNewVideoNoteModal({ loading: false, status: false });
          getAllVideoNotes();
          setNewVideoNote({ value: '', error: '' });
          setNoteType({ value: 'internal', error: '' });
        } else {
          setNewVideoNote({
            ...newVideoNote,
            error: 'Something went wrong ',
          });
        }
      }
    }
  };

  const handleEditVideoNote = async () => {
    if (videoNoteSelected && videoNoteSelected._id) {
      if (newVideoNoteText.value === '' || newVideoNoteText.value.trim() === '') {
        setNewVideoNoteText({
          ...newVideoNoteText,
          error: 'Please enter video note',
        });
      } else if (newVideoNoteType.value === '' || newVideoNoteType.value.trim() === '') {
        setNewVideoNoteType({
          ...newVideoNoteType,
          error: 'Please select video note type',
        });
      } else {
        setVideoNotesData({ ...videoNotesData, loading: true });
        const formData = {
          noteText: newVideoNoteText.value,
          noteType: newVideoNoteType.value,
        };

        const data = await dispatch(updateVideoNotesAction(videoNoteSelected._id, formData));

        if (data && data.status === 'success') {
          getAllVideoNotes();
          setNewVideoNoteText({ value: '', error: '' });
          setNewVideoNoteType({ value: '', error: '' });
          setVideoNoteSelected({});
          toast.success('Video Note Updated Successfully!');
        } else {
          setVideoNotesData({ ...videoNotesData, loading: false });
          setNewVideoNoteType({
            ...newVideoNoteType,
            error: 'Something went wrong.',
          });
        }
      }
    } else {
      alert('Please select video note');
    }
  };

  const handleDeleteNote = async () => {
    if (videoNotesDeleteModal.data && videoNotesDeleteModal.data._id) {
      setVideoNotesDeleteModal(oldData => ({
        ...oldData,
        loading: true,
      }));
      const data = await dispatch(deleteVideoNotesAction(videoNotesDeleteModal.data._id));

      setVideoNotesDeleteModal(oldData => ({
        ...oldData,
        loading: false,
      }));

      if (data && data.status === 'success') {
        getAllVideoNotes();
        setVideoNotesDeleteModal({
          loading: false,
          status: false,
          data: {},
        });
        toast.error('Video Note Deleted Successfully!');
      } else {
        setVideoNotesData({ ...videoNotesData, loading: false });
        setNewVideoNoteType({
          ...newVideoNoteType,
          error: 'Something went wrong.',
        });
      }
    } else {
      alert('Please select video note');
    }
  };

  function decryptSymmetricKey(relationID, encryptedSymmetricKey, randomKey) {
    try {
      const splitKey = encryptedSymmetricKey.split('|');
      const randomModifiedKey = randomKey.split('-').reverse().join('');
      const key = relationID.replace('$', '').split('@').reverse().join(randomModifiedKey);

      const decryptedKey = CryptoJS.AES.decrypt(splitKey[0], key);
      return decryptedKey.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      return '';
    }
  }

  const decryptMessageByKeyId = React.useCallback(
    async (encryptedMessage, decryptKey, channelID, symmetricKey, key) => {
      try {
        if (symmetricKey && key) {
          const decryptKey = decryptSymmetricKey(channelID, symmetricKey, key);
          const decryptedKey = CryptoJS.AES.decrypt(encryptedMessage, decryptKey);
          return decryptedKey.toString(CryptoJS.enc.Utf8);
        }
      } catch (error) {
        return '';
      }
    },
    [dispatch],
  );

  function encryptMessage(relationID, message, randomKey) {
    try {
      if (decryptedSecurityKey !== '') {
        const encryptedMessage = CryptoJS.AES.encrypt(message, decryptedSecurityKey).toString();
        return encryptedMessage;
      } else return '';
    } catch (error) {
      return '';
    }
  }

  const decryptMessage = React.useCallback((encryptedMessage, decryptedSecurityKey) => {
    try {
      const decryptedKey = CryptoJS.AES.decrypt(encryptedMessage, decryptedSecurityKey);
      return decryptedKey.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      return '';
    }
  }, []);

  const checkOnline = currentUser => {
    return (
      onlineUsers && onlineUsers.onlineUsers && onlineUsers.onlineUsers.length > 0 && onlineUsers.onlineUsers.some(onlineUser => onlineUser['userId'] === currentUser)
    );
  };

  const checkOnlineAndGetData = currentUser => {
    return (
      onlineUsers && onlineUsers.onlineUsers && onlineUsers.onlineUsers.length > 0 && onlineUsers.onlineUsers.find(onlineUser => onlineUser['userId'] === currentUser)
    );
  };

  React.useEffect(() => {
    if (socket) {
      socket.on('went-offline', user => {
        if ((selectedUser && selectedUser._id) === user.userId) {
          const newSelectedUser = {
            ...selectedUser,
            lastSeenTime: Date.now(),
          };
          setSelectedNewUser(newSelectedUser);
        }
        setNewSocketUserMsg(true);
      });
    }
  }, [socket, selectedUser]);

  const [newSocketMsg, setNewSocketMsg] = React.useState({});
  const [newSocketUserMsg, setNewSocketUserMsg] = React.useState(false);

  React.useEffect(() => {
    if (socket) {
      socket.on('newMessage', message => {
        if (message.message) {
          setNewSocketMsg(message.message);
        }
      });
    }
  }, [socket]);

  React.useEffect(() => {
    if (socket) {
      socket.on('RemovedFromGroupResponse', message => {
        setRemovedGroupId(message.groupId);
        if (selectedUser._id === removedGroupId) {
          setRemovedGroup(true);
        }
      });
    }
  }, [socket]);

  React.useEffect(() => {
    if (selectedUser._id === removedGroupId) {
      setRemovedGroup(true);
    } else setRemovedGroup(false);
  }, [removedGroupId, selectedUser, socket]);

  React.useEffect(() => {
    if (newSocketMsg && Object.keys(newSocketMsg).length > 0 && encryptedChatData && encryptedChatData.data) {
      const combinedChat = [...encryptedChatData.data, newSocketMsg];
      const newEncChatData = { ...encryptedChatData, data: combinedChat };
      setEncryptedChatData(newEncChatData);
      setNewSocketMsg({});
    }
  }, [newSocketMsg, encryptedChatData]);

  React.useEffect(() => {
    if (socket && encryptedChatData && encryptedChatData.data) {
      socket.on('reactMessage', message => {
        const messageId = message.message.messageId;
        encryptedChatData?.data?.forEach(chat => {
          if (chat.messageId === messageId) chat.reaction = message.message.reaction;
        });
        setEncryptedChatData(encryptedChatData);
        setShowReactBox({ status: false, chat: {} });
      });
    }
  }, [socket, encryptedChatData]);

  React.useEffect(() => {
    if (socket && acceptedUsers) {
      const handleNewMessage = message => {
        setNewSocketUserMsg(true);
        setAcceptedUsers(prevAcceptedUsers => {
          const newAcceptedUsersData = prevAcceptedUsers.data.map(user => {
            if (user.channelID === message.channelID) {
              return {
                ...user,
                lastMessage: message.message,
                unReadMessageCount: 0,
              };
            }
            return user;
          });
          return { ...prevAcceptedUsers, data: newAcceptedUsersData };
        });
      };

      socket.on('newMessage', handleNewMessage);
      socket.on('messageError', ({ message }) => {
        toast.error(message || 'Message failed to send. Please try again.');
      });

      return () => {
        socket.off('newMessage', handleNewMessage);
        socket.off('messageError');
      };
    }
  }, [socket, acceptedUsers]);

  React.useEffect(() => {
    let isMounted = true;

    const getEncSecKey = async (channelID, lastMessageId) => {
      if (!isMounted) return;
      setChatUserLoading(true);
      try {
        const key = await dispatch(getSecurityKeyAction(channelID));
        setEncryptedSecurityKey(key);

        const chatData = await dispatch(getChatsAction(channelID, lastMessageId));
        if (chatData && chatData.status === 'success') {
          setEncryptedChatData(chatData);
        } else {
          setEncryptedChatData({
            status: 'success',
            data: [],
            has_more: false,
          });
        }

        const secKeys = await dispatch(getAllSecurityKeyAction(channelID));
        setSecurityKeys(secKeys);
      } catch (error) {
        console.error('Error fetching encrypted security key or chat data:', error);
      } finally {
        if (isMounted) {
          setChatUserLoading(false);
        }
      }
    };

    if (selectedUser && selectedUser.channelID) {
      const lastMessageId = selectedUser?.lastMessage?.messageId || 0;
      getEncSecKey(selectedUser.channelID, lastMessageId);
    }

    return () => {
      isMounted = false;
    };
  }, [dispatch, selectedUser]);

  React.useEffect(() => {
    if (socket && acceptedUsers) {
      const handleNewMessage = message => {
        setNewSocketUserMsg(true);
        setAcceptedUsers(prevAcceptedUsers => {
          const newAcceptedUsersData = prevAcceptedUsers.data.map(user => {
            if (user.channelID === message.channelID) {
              if (message.ToReplayMessage) {
                const unReadMessageCount = selectedUser.channelID === message.message.channelID ? 0 : (user.unReadMessageCount || 0) + 1;
                return {
                  ...user,
                  lastMessage: message.ToReplayMessage,
                  unReadMessageCount,
                };
              } else {
                const unReadMessageCount = selectedUser.channelID === message.message.channelID ? 0 : (user.unReadMessageCount || 0) + 1;
                return {
                  ...user,
                  lastMessage: message.message,
                  unReadMessageCount,
                };
              }
            }
            return user;
          });
          return { ...prevAcceptedUsers, data: newAcceptedUsersData };
        });
      };

      socket.on('newIncMessage', handleNewMessage);

      return () => {
        socket.off('newIncMessage', handleNewMessage);
      };
    }
  }, [socket, acceptedUsers, selectedUser]);

  React.useEffect(() => {
    if (socket && selectedUser && selectedUser.channelID) {
      socket.emit('joinRoom', {
        chatroomId: selectedUser.channelID,
        dest_user: selectedUser._id,
        user: userLogin.userInfo.data.user._id,
      });
    }

    return () => {
      if (socket && selectedUser && selectedUser.channelID) {
        socket.emit('leaveRoom', {
          chatroomId: selectedUser.channelID,
          dest_user: selectedUser._id,
          user: userLogin.userInfo.data.user._id,
        });
      }
    };
  }, [selectedUser, socket]);

  React.useEffect(() => {
    getAllUsers();
  }, [getAcceptedUsers, getAllUsers]);

  React.useEffect(() => {
    getAcceptedUsers();
  }, []);

  React.useEffect(() => {
    getAllVideoNotes();
  }, [getAllVideoNotes]);

  React.useEffect(() => {
    if (videoNoteSelected && Object.keys(videoNoteSelected).length > 0) {
      setNewVideoNoteText({
        value: videoNoteSelected.noteText,
        error: '',
      });
      setNewVideoNoteType({
        value: videoNoteSelected.noteType,
        error: '',
      });
    }
  }, [videoNoteSelected]);

  React.useEffect(
    () => {
      const acceptedUsersData = acceptedUsers && acceptedUsers.data;

      if (acceptedUsersData && selectedUser && selectedUser.channelID) {
        if (socket) {
          socket.emit('read-message', {
            chatroomId: selectedUser.channelID,
            user: userLogin?.userInfo?.data?.user?._id,
            messageId: selectedUser?.lastMessage?.messageId,
          });
        }

        const newAcceptedUsersData = acceptedUsersData.map(user => {
          if (user.channelID === selectedUser.channelID) {
            return { ...user, unReadMessageCount: 0 };
          } else {
            return user;
          }
        });
        const newAcceptedUsers = {
          ...acceptedUsers,
          data: newAcceptedUsersData,
        };
        setAcceptedUsers(newAcceptedUsers);
      }
    },
    // eslint-disable-next-line
    [selectedUser],
  );

  React.useEffect(() => {
    const getEncSecKey = async (channelID, lastMessageId) => {
      setChatUserLoading(true);
      const key = await dispatch(getSecurityKeyAction(channelID));
      setEncryptedSecurityKey(key);

      const chatData = await dispatch(getChatsAction(channelID, lastMessageId));
      if (chatData && chatData.status === 'success') {
        setEncryptedChatData(chatData);
      } else if (chatData && chatData.status === 'fail') {
        setEncryptedChatData({
          status: 'success',
          data: [],
          has_more: false,
        });
      }

      const secKeys = await dispatch(getAllSecurityKeyAction(channelID));
      setSecurityKeys(secKeys);
      setChatUserLoading(false);
    };

    if (selectedUser && selectedUser.channelID) {
      const lastMessageId = selectedUser?.lastMessage?.messageId ? selectedUser.lastMessage.messageId : 0;
      getEncSecKey(selectedUser.channelID, lastMessageId);
    }
  }, [dispatch, selectedUser]);

  React.useEffect(() => {
    const decryptKey = async () => {
      if (
        selectedUser &&
        selectedUser.channelID &&
        encryptedSecurityKey &&
        encryptedSecurityKey.status === 'success' &&
        encryptedSecurityKey.data &&
        encryptedSecurityKey.data.symmetricKey
      ) {
        const decryptKey = decryptSymmetricKey(selectedUser.channelID, encryptedSecurityKey.data.symmetricKey, encryptedSecurityKey.data.key);

        setDecryptedSecurityKey(decryptKey);
      }
    };
    decryptKey();
  }, [encryptedSecurityKey, selectedUser]);

  React.useEffect(() => {
    if (
      encryptedChatData &&
      encryptedChatData.status === 'success' &&
      encryptedChatData.data &&
      encryptedChatData.data.length > 0 &&
      selectedUser &&
      selectedUser.channelID
    ) {
      const decryptedMessages = [];
      encryptedChatData.data.forEach(message => {
        const decSymKey = decryptSymmetricKey(selectedUser.channelID, message.symmetricKey, message.key);
        let newMsg;
        if (message.isEncryptedMessage) {
          const messageText = decryptMessage(message.messageText, decSymKey);
          newMsg = { ...message, messageText };

          if (message.ToReplayMessage && message.ToReplayMessage.messageText) {
            const replyDecSymKey = decryptSymmetricKey(selectedUser.channelID, message.ToReplayMessage.symmetricKey, message.ToReplayMessage.key);

            const messageText = decryptMessage(message.messageText, decSymKey);
            const replyMessageText = decryptMessage(message.ToReplayMessage.messageText, replyDecSymKey);
            newMsg = {
              ...message,
              messageText,
              ToReplayMessage: {
                ...message.ToReplayMessage,
                messageText: replyMessageText,
              },
            };
          }
        } else {
          newMsg = { ...message };
        }

        decryptedMessages.push(newMsg);
      });
      setDecryptedChatData(decryptedMessages);
      setChatSendLoading(true);
      setTimeout(() => {
        setChatSendLoading(false);
      }, 100);
    }
  }, [encryptedChatData, decryptMessage, selectedUser]);

  React.useEffect(() => {
    const result = decryptedChatData.reduce(function (r, a) {
      const date = new Date(a.messageTime).toDateString();
      r[date] = r[date] || [];
      r[date].push(a);
      return r;
    }, Object.create(null));

    setGroupedData(result);
  }, [decryptedChatData, encryptedChatData]);

  const getMoreChats = async () => {
    if (encryptedChatData && encryptedChatData.has_more && selectedUser && selectedUser.channelID && selectedUser.lastMessage) {
      setLoadMoreMsg(true);
      setLastTopMessage(encryptedChatData.data[0]);
      const lastMessageId = encryptedChatData.data[0].messageId;
      const chatData = await dispatch(getChatsAction(selectedUser.channelID, lastMessageId - 1));

      if (chatData && chatData.data) {
        const data = encryptedChatData && encryptedChatData.data;
        const combinedChat = [...chatData.data, ...data];
        setEncryptedChatData({ ...chatData, data: combinedChat });
      }
    }
  };

  const sendChat = (chatText, keyID) => {
    if (socket && selectedUser && selectedUser.channelID) {
      const socketId = onlineUsers && onlineUsers.onlineUsers && onlineUsers.onlineUsers.find(user => user.userId === selectedUser._id);
      setLoadMoreMsg(false);
      if (selectedMessage && selectedMessage.senderId) {
        setChatSendLoading(true);
        const emitMessage = {
          chatroomId: selectedUser.channelID,
          message: chatText,
          messageId: selectedMessage.messageId,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          groupId: selectedUser.groupId,
          messageType: selectedUser.type,
          keyID,
          user: selectedUser._id,
          socketId,
        };
        socket.emit('chatroomReplyMessage', emitMessage);
        setSelectedMessage({});
      } else {
        setChatSendLoading(true);
        const emitMessage = {
          chatroomId: selectedUser.channelID,
          message: chatText,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          keyID,
          groupId: selectedUser.groupId,
          messageType: selectedUser.type,
          user: selectedUser._id,
          socketId,
        };
        socket.emit('chatroomMessage', emitMessage);
      }
      setChatText({ value: '', error: '' });
    }
  };

  const chatUser = async () => {
    setShowEmojiBox(false);
    if ((chatText.value === '' || chatText.value.trim() === '') && attachedFiles.length === 0) {
      setChatText({ ...chatText, error: true });
    } else {
      if (
        selectedUser &&
        selectedUser.channelID &&
        encryptedSecurityKey &&
        encryptedSecurityKey.status === 'success' &&
        encryptedSecurityKey.data &&
        encryptedSecurityKey.data.symmetricKey
      ) {
        const splitKey = encryptedSecurityKey.data.symmetricKey.split('|');
        const messageText = chatText.value || (attachedFiles.length > 0 ? `[${attachedFiles.length} file(s) attached]` : '');
        const encryptedMessage = encryptMessage(selectedUser.channelID, messageText, splitKey[1]);
        sendChat(encryptedMessage, splitKey[1]);

        // Upload files if any
        if (attachedFiles.length > 0) {
          for (const file of attachedFiles) {
            const fd = new FormData();
            fd.append('file', file);
            try {
              await axios.post(`${process.env.REACT_APP_BASE_URL}/chat/${selectedUser.channelID}/upload`, fd, { withCredentials: true });
            } catch (err) {
              toast.error(`Failed to upload ${file.name}`);
            }
          }
          setAttachedFiles([]);
        }
      }
    }
  };

  const onEmojiClick = (event, emojiObject) => {
    const newChatText = chatText.value + emojiObject.emoji;
    setChatText({ ...chatText, value: newChatText });
  };

  const reactToChat = async (reaction, messageId) => {
    if (socket && selectedUser && selectedUser.channelID) {
      const emitMessage = {
        chatroomId: selectedUser.channelID,
        messageId: messageId,
        user: selectedUser._id,
        reaction: reaction,
      };
      socket.emit('chatroomReactOnMessage', emitMessage);
    }
  };

  const handleCreateKey = async () => {
    if (selectedUser && selectedUser.channelID) {
      setSecurityKeyCreate(true);
      const formData = {
        relationId: selectedUser.channelID,
        keyType: 'chat',
      };
      const key = await dispatch(createSecurityKeyAction(formData));

      if (key && key.status === 'success') {
        toast.success('Generated and using new security key', {
          style: { borderRadius: '10px', background: '#3C0016', color: '#fff' },
        });
        setSecurityKeyModal(false);
        setChatUserLoading(true);
        const key2 = await dispatch(getSecurityKeyAction(selectedUser.channelID));
        setEncryptedSecurityKey(key2);

        const lastMessageId = selectedUser?.lastMessage?.messageId || 0;
        const chatData = await dispatch(getChatsAction(selectedUser.channelID, lastMessageId));
        setEncryptedChatData(chatData);

        const secKeys = await dispatch(getAllSecurityKeyAction(selectedUser.channelID));
        setSecurityKeys(secKeys);
        setChatUserLoading(false);
        setShowSecurityKey(false);
      }
      setSecurityKeyCreate(false);
    }
  };

  const handleMakeDefaultKey = async keyID => {
    if (selectedUser && selectedUser.channelID) {
      const newKey = await dispatch(makeDefaultSecurityKeyAction(keyID));

      if (newKey && newKey.status === 'success') {
        toast.success(newKey.message, {
          style: { borderRadius: '10px', background: '#3C0016', color: '#fff' },
        });
        setChatUserLoading(true);
        const key = await dispatch(getSecurityKeyAction(selectedUser.channelID));
        setEncryptedSecurityKey(key);

        const lastMessageId = selectedUser?.lastMessage?.messageId || 0;
        const chatData = await dispatch(getChatsAction(selectedUser.channelID, lastMessageId));
        setEncryptedChatData(chatData);

        const secKeys = await dispatch(getAllSecurityKeyAction(selectedUser.channelID));
        setSecurityKeys(secKeys);
        setChatUserLoading(false);
        setShowSecurityKey(false);
      } else if (newKey && newKey.status === 'fail') {
        toast.success('Something went wrong', {
          style: { borderRadius: '10px', background: '#3C0016', color: '#fff' },
        });
      }
    }
  };

  const requestVideoCallToSelectedUser = async user => {
    if (socket && selectedUser) {
      const id = checkOnlineAndGetData(selectedUser._id);
      if (id) {
        history.push(`/make/call/video/${selectedUser._id}/${selectedUser.name}/${id.socketId}`);
      }
    }
  };

  React.useEffect(() => {
    if (socket) {
      socket.on('unencryptedMessageSocket', message => {
        if (message && message?.messageObject) {
          const newDecrypt = [...decryptedChatData];
          newDecrypt.push(message?.messageObject);
          setDecryptedChatData(newDecrypt);
        }
        setLatestUnecryptedMessage(true);
      });
    }
  }, [socket, groupedData, decryptedChatData]);

  React.useEffect(() => {
    setChatText({ ...chatText, value: '' });
  }, [selectedUser]);

  return {
    messagesStartRef,
    messagesEndRef,
    lastTopMessage,
    acceptedUserLoading,
    showAddGroupMoal,
    setShowAddGroupMoal,
    showGroupInfoMoal,
    setShowGroupInfoMoal,
    acceptedUsers,
    allUsers,
    selectedUser,
    setSelectedUser,
    showSelectedUser,
    setShowSelectedUser,
    showChatRequests,
    setShowChatRequests,
    selectedNewUser,
    setSelectedNewUser,
    acceptedUserSearch,
    setAcceptedUserSearch,
    chatUserLoading,
    chatSendLoading,
    showEmojiBox,
    setShowEmojiBox,
    showErrorToast,
    setShowErrorToast,
    showSuccessToast,
    setShowSuccessToast,
    toastMessage,
    showReactBox,
    setShowReactBox,
    removedGroup,
    selectedMessage,
    setSelectedMessage,
    encryptedSecurityKey,
    encryptedChatData,
    setEncryptedChatData,
    decryptedChatData,
    setDecryptedChatData,
    groupedData,
    groupName,
    setGroupName,
    chatText,
    setChatText,
    attachedFiles,
    setAttachedFiles,
    fileInputRef,
    securityKeys,
    securityKeyModal,
    setSecurityKeyModal,
    securityKeyCreate,
    showSecurityKey,
    setShowSecurityKey,
    topMessageRef,
    videoNotesModal,
    setVideoNotesModal,
    group,
    setGroup,
    videoNotesData,
    videoNoteSelected,
    setVideoNoteSelected,
    newVideoNoteText,
    setNewVideoNoteText,
    newVideoNoteType,
    setNewVideoNoteType,
    videoNotesDeleteModal,
    setVideoNotesDeleteModal,
    addNewVideoNoteModal,
    setAddNewVideoNoteModal,
    newVideoNote,
    setNewVideoNote,
    noteType,
    setNoteType,
    userLogin,
    setLoadMoreMsg,
    getAcceptedUsers,
    handleSubmitVideoNote,
    handleEditVideoNote,
    handleDeleteNote,
    decryptMessageByKeyId,
    checkOnline,
    checkOnlineAndGetData,
    newSocketUserMsg,
    getMoreChats,
    chatUser,
    onEmojiClick,
    reactToChat,
    handleCreateKey,
    handleMakeDefaultKey,
    requestVideoCallToSelectedUser,
  };
};

export default useChatFunctions;
